(function (angular) {
    'use strict';

    var SIDEBAR_OPEN = "1";
    angular.module('app')
        /**
         * 
         */
        .controller('materialadminCtrl', ['$rootScope', '$scope', '$state', 'jwtService', 'themeService', 'portalConfig',
            function ($rootScope, $scope, $state, jwtService, themeService, portalConfig) {
                if (jwtService.payload) {
                    $scope.impersonate = jwtService.payload.impersonatorUserName;
                }
                // For Mainmenu Active Class
                this.$state = $state;

                this.theme = "default";
                this.themeLoaded = false;

                this.onThemeLoaded = function () {
                    this.themeLoaded = true;
                }

                this.getThemeUrl = function () {
                    try {
                        var palette = themeService.getThemeInfo().colourPalette;

                        var version = portalConfig.versionNumber;

                        if(portalConfig.buildNumber){
                            version += ("." + portalConfig.buildNumber);
                        }

                        return "primary=" + encodeURIComponent(palette.primary) +
                            "&success=" + encodeURIComponent(palette.success) +
                            "&danger=" + encodeURIComponent(palette.danger) +
                            "&info=" + encodeURIComponent(palette.info) +
                            "&warning=" + encodeURIComponent(palette.warning) +
                            "&version=" + version;
                    } catch (e) {
                        return "";
                    }

                }

                this.currentState = function () {
                    return this.$state.current.name;
                }

                // Detect Mobile Browser
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    angular.element('html').addClass('ismobile');
                }

                // By default Sidbars are hidden in boxed layout and in wide layout only the right sidebar is hidden.
                this.sidebarToggle = {
                    left: false,
                    right: false
                };

                var self = this;
                $rootScope.$on("materialAdmin:layoutType", function (event, layoutType) {
                    self.layoutType = layoutType;
                });

                // By default template has a boxed layout
                this.layoutType = SIDEBAR_OPEN;

                //Close sidebar on click
                this.sidebarStat = function (event) {
                    if (!angular.element(event.target).parent().hasClass('active')) {
                        this.sidebarToggle.left = false;
                    }
                };
            }]);

})(window.angular);